import type { ConnectedFacility } from '../../../../../js/api/models/ConnectedFacility';
import { ProviderExpenseAndTermsForm } from '../../../components/provider-expenses-and-terms-form';

type TravelTabProps = {
  connection: ConnectedFacility;
};

export function TravelTab({ connection }: TravelTabProps) {
  return (
    <div className="tw:space-y-4">
      <ProviderExpenseAndTermsForm connection={connection} />
    </div>
  );
}
